"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = require("../");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TaskTypeEnum;

(function (TaskTypeEnum) {
  TaskTypeEnum["collection"] = "collection";
  TaskTypeEnum["delivery"] = "delivery";
})(TaskTypeEnum || (TaskTypeEnum = {}));

function LogisticTask(props) {
  let isPishkhan = !!props.taskLink;
  return /*#__PURE__*/_react.default.createElement(_.Box, {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/_react.default.createElement(_.Stack, {
    alignment: "stretch",
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/_react.default.createElement(_.Spacer, {
    size: "m"
  }), /*#__PURE__*/_react.default.createElement(_.Box, {
    pl: "l",
    pb: props.data.task_type === "collection" ? "xxl" : "",
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/_react.default.createElement(_.Typography, {
    color: "text.light950"
  }, props.data.task_type === "collection" ? "جمع آوری" : "تحویل"), /*#__PURE__*/_react.default.createElement(_.Divider, {
    size: "m"
  }), !!props.data.address_latitude && !!props.data.address_longitude && isPishkhan ? /*#__PURE__*/_react.default.createElement("a", {
    target: "_blank",
    href: `https://www.google.com/maps/place/${props.data.address_latitude},${props.data.address_longitude}`
  }, /*#__PURE__*/_react.default.createElement(_.Stack, null, /*#__PURE__*/_react.default.createElement(_.Typography, {
    ff: "mainBold",
    numberOfLines: 100
  }, props.data.address_text))) : /*#__PURE__*/_react.default.createElement(_.Stack, null, /*#__PURE__*/_react.default.createElement(_.Typography, {
    ff: "mainBold",
    numberOfLines: 100
  }, props.data.address_text)), props.data.period.title ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.Divider, {
    size: "m"
  }), /*#__PURE__*/_react.default.createElement(_.Typography, {
    color: "text.light950"
  }, props.data.period.title)) : null, props.footer && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.Divider, {
    size: "m"
  }), props.footer))));
}

var _default = LogisticTask;
exports.default = _default;